var React = require('react');

function IconPlusBase16x16 (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":".Plus Base","clipPath":"url(#clip0_6407_830)","key":0},React.createElement("path",{"id":"Path","d":"M8.00004 14.6667V1.33333M14.6667 8H1.33337","stroke":"#142B6F","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_6407_830"},React.createElement("rect",{"width":"16","height":"16","fill":"white"})))]);
}

IconPlusBase16x16.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = IconPlusBase16x16;

IconPlusBase16x16.default = IconPlusBase16x16;
